import React, { useEffect, useState } from "react";
import { updateConversationStatus } from "../../services/conversationStatusApi";
import "./ConversationStatus.css";

const STATUS_OPTIONS = [
  "open",
  "pending",
  "escalated",
  "closed",
];

const ConversationStatus = ({
  conversationId,
  currentStatus,
  onStatusChange,
}) => {
  const [status, setStatus] = useState(
    currentStatus || ""
  );
  const [apiState, setApiState] = useState("idle");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setStatus(currentStatus || "");
    setApiState("idle");
    setErrorMessage("");
  }, [conversationId, currentStatus]);

  const handleStatusChange = async (newStatus) => {
    if (!conversationId) {
      setApiState("error");
      setErrorMessage("Please select a conversation.");
      return;
    }

    if (!STATUS_OPTIONS.includes(newStatus)) {
      setApiState("error");
      setErrorMessage("Invalid conversation status.");
      return;
    }

    if (newStatus === status) {
      return;
    }

    setApiState("loading");
    setErrorMessage("");

    try {
      const response = await updateConversationStatus(
        conversationId,
        newStatus
      );

      if (response.success) {
        setStatus(newStatus);
        onStatusChange(response.data.status);

        setApiState("success");

        setTimeout(() => {
          setApiState("idle");
        }, 1200);
      }
    } catch (error) {
      setApiState("error");
      setErrorMessage(
        "Failed to update status. Please try again."
      );
    }
  };

  return (
    <div className="conversation-status">

      {/* Header */}
      <div className="conversation-status-header">
        <h3>Conversation Status</h3>
        <span>Status</span>
      </div>

      {/* Empty State */}
      {!conversationId && (
        <div className="status-empty">
          No conversation selected.
        </div>
      )}

      {conversationId && (
        <>
          {/* Status Options */}
          <div className="status-options">
            {STATUS_OPTIONS.map((item) => (
              <button
                key={item}
                type="button"
                className={`status-option status-${item} ${
                  status === item ? "active" : ""
                }`}
                onClick={() =>
                  handleStatusChange(item)
                }
                disabled={apiState === "loading"}
              >
                {item.charAt(0).toUpperCase() +
                  item.slice(1)}
              </button>
            ))}
          </div>

          {/* Loading */}
          {apiState === "loading" && (
            <div className="status-loading">
              Updating status...
            </div>
          )}

          {/* Success */}
          {apiState === "success" && (
            <div className="status-success">
              Status updated successfully!
            </div>
          )}

          {/* Error */}
          {apiState === "error" && (
            <div className="status-error">
              {errorMessage}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ConversationStatus;